import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EnumerationDataTypeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EnumerationDataType",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.83 4.71c-.36 0-.68.16-.94.47l-9.46 9.46-4.25-4.33a1.173 1.173 0 0 0-1.65 0c-.22.22-.34.52-.34.83s.12.61.34.82l5.14 5.14c.22.22.52.35.83.35s.61-.12.82-.34L29.59 6.79c.27-.23.42-.56.42-.9 0-.64-.53-1.17-1.17-1.17Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.42 14.08c-.66 0-1.2.54-1.2 1.2v5.26c0 .26-.21.48-.48.48h-14.4a.48.48 0 0 1-.48-.48V6.14c0-.27.21-.48.48-.48h12.89c.66 0 1.2-.54 1.2-1.2s-.54-1.2-1.2-1.2H8.65c-.66 0-1.2.54-1.2 1.2v4.12H3.2c-.66 0-1.2.54-1.2 1.2v17.77c0 .66.54 1.2 1.2 1.2h17.77c.66 0 1.2-.54 1.2-1.2v-4.12h4.24c.66 0 1.2-.54 1.2-1.2v-6.95c0-.66-.54-1.2-1.2-1.2ZM19.3 26.35H4.88a.48.48 0 0 1-.48-.48v-14.4c0-.27.22-.49.49-.49h2.55v11.25c0 .66.54 1.2 1.2 1.2h11.12v2.43c0 .26-.21.48-.48.48h.02Z"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.57 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V7.57a1.14 1.14 0 1 1 2.28 0v18.29c0 .63.51 1.14 1.14 1.14h18.29a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.86 24.71h-16c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h16c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43Zm-16-20.57c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14h-16Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.84 17.48c-.3 0-.59-.12-.81-.33l-3.56-3.56a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l2.71 2.71 4.78-5.21c.43-.46 1.15-.5 1.61-.07.47.43.5 1.15.07 1.62l-5.59 6.09c-.21.23-.51.36-.82.37h-.02Z"
      })]
    })
  }));
};